
import { useTranslation } from 'react-i18next';

const OwnerIntro = () => {
  const { t } = useTranslation('common');

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Owner Photo */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="w-full max-w-lg h-[600px] rounded-2xl bg-white p-6 shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-300">
                <img
                  src="https://static.readdy.ai/image/42d13efc32449c379a28fcec32248951/43e47bc0135f16267a464c8a3f4fef40.jpeg"
                  alt="Vasile Comanov - Owner of Alpbuild.ch"
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full opacity-20"></div>
              <div className="absolute -bottom-8 -left-8 w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full opacity-20"></div>
              <div className="absolute top-1/2 -right-4 w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full opacity-15"></div>
            </div>
          </div>

          {/* Text Content */}
          <div className="order-1 lg:order-2 lg:pt-8">
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-800 rounded-full text-sm font-medium mb-6">
              <i className="ri-user-star-line mr-2"></i>
              Meet the Owner
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Vasile Comanov
            </h2>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Bonjour! Je suis Vasile Comanov, fondateur et propriétaire d'Alpbuild.ch. Avec plus de 21 ans d'expérience dans le secteur de la construction en Suisse, j'ai consacré ma carrière à offrir des services de construction et de rénovation de la plus haute qualité.
              </p>
              
              <p>
                Ma passion pour la précision et l'excellence suisse se reflète dans chaque projet que nous entreprenons. Que ce soit une rénovation complète ou des travaux de finition spécialisés, je m'engage personnellement à garantir que chaque détail répond aux normes les plus élevées.
              </p>
              
              <p>
                Basé dans les cantons de Vaud et Genève, je travaille directement avec mes clients pour transformer leurs visions en réalité. Mon expertise couvre tous les aspects de la construction et de la rénovation, avec un focus particulier sur la qualité et la précision qui caractérisent le savoir-faire suisse.
              </p>
              
              <p>
                Votre satisfaction et la qualité du travail sont mes priorités absolues. Chaque projet est une opportunité de démontrer notre engagement envers l'excellence et notre respect des délais convenus.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-10">
              <div className="text-center p-4 bg-white rounded-xl shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-1">21+</div>
                <div className="text-sm text-gray-600">Années d'expérience</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-1">80+</div>
                <div className="text-sm text-gray-600">Projets réalisés</div>
              </div>
              <div className="text-center p-4 bg-white rounded-xl shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-1">100%</div>
                <div className="text-sm text-gray-600">Satisfaction client</div>
              </div>
            </div>

            {/* Certifications */}
            <div className="mt-8 flex flex-wrap gap-3">
              <div className="flex items-center px-4 py-2 bg-gray-100 rounded-lg">
                <i className="ri-shield-check-line text-teal-600 text-xl mr-2"></i>
                <span className="text-sm font-medium text-gray-700">Certifié Suisse</span>
              </div>
              <div className="flex items-center px-4 py-2 bg-gray-100 rounded-lg">
                <i className="ri-award-line text-teal-600 text-xl mr-2"></i>
                <span className="text-sm font-medium text-gray-700">Qualité Garantie</span>
              </div>
              <div className="flex items-center px-4 py-2 bg-gray-100 rounded-lg">
                <i className="ri-team-line text-teal-600 text-xl mr-2"></i>
                <span className="text-sm font-medium text-gray-700">Équipe Professionnelle</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OwnerIntro;
